var exports = {
  "kL": "x127c5a35--c0694e--container",
  "nf": "x127c5a35--c0694e--link",
  "$d": "x127c5a35--c0694e--link-area",
};

module.exports = exports;
